import { connect } from 'react-redux';

import { isProd } from '../../utils/Utils';

const AdminOnly = ({ noProd, auth, children }) => {
  if (noProd && isProd()) {
    return null;
  }
  if (auth.authorities.indexOf('ADMIN') >= 0) {
    return children;
  }
  return null;
};

export default connect(({ auth }) => ({ auth }))(AdminOnly);



// WEBPACK FOOTER //
// ./src/containers/private/AdminOnly.js